import React from 'react';
import ChatItem from './ChatItem';
import ChatMessages from './ChatMessages';
import MessageInput from './Input';
import Menu from './Menu';

const Mobile = ({ chat, chats, selectedChatId, setSelectedChatId, highlightedChatId }) => {
  return (
    <div style={{ display: 'flex' }}>
      <div className='mobile-app'>
        <Menu chat={chat} setSelectedChatId={setSelectedChatId} />
        {!chat ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              padding: 16,
              gap: 16,
              overflowY: 'auto',
            }}
          >
            {chats.map((chat) => (
              <ChatItem
                key={chat.id}
                chat={chat}
                isSelected={selectedChatId === chat.id}
                onClick={() => setSelectedChatId(chat.id)}
                isHighlighted={highlightedChatId === chat.id}
              />
            ))}
          </div>
        ) : (
          <div className='m-chat-container'>
            <ChatMessages chatId={chat.id} messages={chat?.messages} />
            <MessageInput chat={chat} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Mobile;
